import { render, staticRenderFns } from "./VistaFormularioCamposPrincipalesAcuerdo.vue?vue&type=template&id=70a689fa"
import script from "./VistaFormularioCamposPrincipalesAcuerdo.vue?vue&type=script&lang=js"
export * from "./VistaFormularioCamposPrincipalesAcuerdo.vue?vue&type=script&lang=js"
import style0 from "./VistaFormularioCamposPrincipalesAcuerdo.vue?vue&type=style&index=0&id=70a689fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VForm,VIcon,VRadio,VRadioGroup,VTextField,VTextarea})
